// We will use view_components/storybook to build and view UI components in isolation.
// Keep this file for now, even if empty.
import { application } from './application'
import { controllers as bridgeControllers } from "@joemasilotti/bridge-components"

// Register all Bridge Components
bridgeControllers.forEach((controller) => {
  application.register(controller.identifier, controller.controllerConstructor)
})

import BridgeToastController from './bridge/toast_controller'
application.register('bridge--toast', BridgeToastController)

import UsersOnboardingController from './users/onboarding_controller'
application.register('users--onboarding', UsersOnboardingController)

import BridgeEnvironmentController from './bridge/environment_controller'

application.register('bridge--environment', BridgeEnvironmentController)

import ButtonController from './button_controller'
application.register('button', ButtonController)

import BadgeController from './badge_controller'
application.register('badge', BadgeController)

import QrScannerController from './qr_scanner_controller'
application.register('qr-scanner', QrScannerController)

import QrRotationController from './pacts/qr_rotation_controller'
application.register('qr-rotation', QrRotationController)

import ScannerActionsController from './scanner_actions_controller'
application.register('scanner-actions', ScannerActionsController)

import PactQrChannelController from './pacts/qr_channel_controller'
application.register('pact-qr-channel', PactQrChannelController)

import LandingAccordionController from './landing/accordion_controller'
application.register('landing--accordion', LandingAccordionController)

import LandingHeroController from './landing/hero_controller'
application.register('landing--hero', LandingHeroController)

import LandingHowItWorksController from './landing/how_it_works_controller'
application.register('landing--how-it-works', LandingHowItWorksController)

import LandingWaitlistFormController from './landing/waitlist_form_controller'
application.register('landing--waitlist-form', LandingWaitlistFormController)

import HeroCtaController from './hero_cta_controller'
// Register hero CTA controller under the landing namespace to match ViewComponent class Landing::HeroPrimaryCtaComponent
application.register('landing--hero-primary-cta', HeroCtaController)

import CtaBannerController from './cta_banner_controller'
// Register CTA banner controller under the landing namespace to match ViewComponent class Landing::CtaBannerComponent
application.register('landing--cta-banner', CtaBannerController)

import AnalyticsController from './analytics_controller'
application.register('analytics', AnalyticsController)

import FormSubmissionController from './form_submission_controller'
application.register('form-submission', FormSubmissionController)

import AdminPhrasesController from './admin/phrases_controller'
application.register('admin--phrases', AdminPhrasesController)

import AdminPhrasesBulkEditController from './admin/phrases/bulk_edit_controller'
application.register('admin--phrases--bulk-edit', AdminPhrasesBulkEditController)

import ToastController from './shared/ui/atoms/toast_controller'
application.register('shared--ui--atoms--toast', ToastController)

import AdminLayoutLoadingController from './admin/layout/loading_controller'
application.register('admin--layout--loading', AdminLayoutLoadingController)

// Pact Controller - loads Cleave.js, only used on pact pages
registerLazy('pact', () => import('./pact_controller'))

import UsersPasswordValidationController from './users/password_validation_controller'
application.register('users--password-validation', UsersPasswordValidationController)

import UsersLoadingButtonController from './users/loading_button_controller'
application.register('users--loading-button', UsersLoadingButtonController)

import UsersRolesSelectionComponentController from './users/roles_selection_component_controller'
application.register('users--roles--selection-component', UsersRolesSelectionComponentController)

import UsersPasswordVisibilityController from './users/password_visibility_controller'
application.register('users--password-visibility', UsersPasswordVisibilityController)

import UsersSettingsAvatarController from './users/settings/avatar_controller'
application.register('users--settings--avatar', UsersSettingsAvatarController)

import StripeConnectOnboardingController from './stripe/connect_onboarding_controller'
application.register('stripe--connect-onboarding', StripeConnectOnboardingController)

import PactProductFormController from './pacts/product_form_controller'
application.register('pacts--product-form', PactProductFormController)

import PactPaymentFormComponentController from './pacts/payment/form_component_controller'
application.register('pacts--payment--form-component', PactPaymentFormComponentController)

import PactPaymentStripeFormComponentController from './pacts/payment/stripe_form_component_controller'
application.register('pacts--payment--stripe-form-component', PactPaymentStripeFormComponentController)

import PactPaymentScreenComponentController from './pacts/payment/screen_component_controller'
application.register('pacts--payment--screen-component', PactPaymentScreenComponentController)

import PactProcessingController from './pacts/processing_controller'
application.register('pacts--processing', PactProcessingController)

import AdminPactsSearchController from './admin/pacts/search_controller'
application.register('admin--pacts--search', AdminPactsSearchController)

import AdminPactsDashboardComponentController from './admin/pacts/dashboard_component_controller'
application.register('admin--pacts--dashboard-component', AdminPactsDashboardComponentController)

import AdminOperationalHealthChartController from './admin/operational_health/chart_controller'
application.register('admin--operational-health--chart', AdminOperationalHealthChartController)

import ClipboardController from './clipboard_controller'
application.register('clipboard', ClipboardController)

import ToastAutoShowController from "./toast_auto_show_controller"
application.register("toast-auto-show", ToastAutoShowController)

// ===== LAZY LOADED CONTROLLERS (only loaded if present in DOM) =====
// These controllers are loaded dynamically to reduce initial bundle size
import { registerLazy, loadLazyControllers } from './lazy_loader'

// Currency Controller - only used on specific forms
registerLazy("shared--ui--currency", () => import("./shared/ui/currency_controller"))

import SharedUiModalController from "./shared/ui/modal_controller"
application.register("shared--ui--modal", SharedUiModalController)

import SharedUiDropdownController from "./shared/ui/dropdown_controller"
application.register("dropdown", SharedUiDropdownController)

import NotificationTokenDebugController from "./admin/notification_token_debug_controller"
application.register("admin--notification-token-debug", NotificationTokenDebugController)

import DebugScannerController from "./debug_scanner_controller"
application.register("debug-scanner", DebugScannerController)

import BarcodeScannerDebugController from "./admin/barcode_scanner_debug_controller"
application.register("admin--barcode-scanner-debug", BarcodeScannerDebugController)

import DomainSwitcherController from "./domain_switcher_controller"
application.register("domain-switcher", DomainSwitcherController)

import DebugLoginController from "./debug_login_controller"
application.register("debug-login", DebugLoginController)
// Load lazy controllers after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => loadLazyControllers())
} else {
  loadLazyControllers()
}
// Patch: Ensure lazy controllers reload on Turbo events
document.addEventListener('turbo:render', () => loadLazyControllers())
document.addEventListener('turbo:load', () => loadLazyControllers())
